import React, { useEffect, useState } from 'react';
import { FormControlLabel } from '@mui/material';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import './NotificationsComponent.css'
import CancelIcon from '@mui/icons-material/Cancel';
import logo from '../../assets/logo.png'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import NotificationRow from '../notifications-component/NotificationsRowComponent';
import { usePendingState } from './PendingStateContext';
import { useNotificationAPI } from '../as2-onboarding-component/hooks/useClient';
import { useOktaAuth } from '@okta/okta-react';
import SupplierSelectComponent from "../supplier-select-component/SupplierSelectComponent";
import CircularProgress from "@mui/material/CircularProgress";
import axios from 'axios';

const NotificationsComponent = ({ supplierList, handleKeyDown, userType }) => {
    const { oktaAuth } = useOktaAuth();

    const { updatePendingState } = usePendingState();
    const [showComponent, setShowComponent] = useState('P'); // 'P' for Pending, 'C' for Complete
    const [submitted, setSubmitted] = useState(false);
    const [btnDisplay, setBtnDisplay] = useState(true);
    const [review, setReview] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [pendingRows, setPendingRows] = useState([]);
    const [completedRows, setCompletedRows] = useState([]);
    const [selectedSupplierLabel, setSelectedSupplierLabel] = useState('');
    const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
    const [isLoadingSubmitted, setIsLoadingSubmitted] = useState(false);
    const [dropdownSuppliers, setDropdownSuppliers] = useState([]);
    const ALL_MY_SUPPLIERS_STRING = "SELECT ALL MY SUPPLIERS";


    const notificationApi = useNotificationAPI(oktaAuth.getAccessToken());

    const fetchData = async (supplierNumbersArray) => {
        setIsLoadingNotifications(true);
        try{
            // const response = await notificationApi.get('/notifications/supplier?supplier_number=' + supplierNumber);
            const response = await notificationApi.post('/notifications/supplier', {
                suppliers_numbers: supplierNumbersArray
            });

            const data = response.data;
            const pending = [];
            const completed = [];

            const priorityLabels = {
                0: 'Low',
                1: 'Medium',
                2: 'High'
            };

            // data.map((element) => {
            //     if (element.notification_read === false) {
            //         pending.push({id: element.notification.id, status: 'Pending', title: element.notification.title,
            //             received: element.notification.creation_date.substring(0,10),
            //             dueDate: element.notification.due_date, action: 'Review', priority: priorityLabels[element.notification.priority] || 'Unknown',
            //             content: element.notification.notification_text});
            //     }
            //     else{t
            //         completed.push({id: element.notification.id, status: 'Completed', title: element.notification.title,
            //             received: element.notification.creation_date.substring(0,10),
            //             dueDate: element.notification.due_date, action: 'Review', priority: priorityLabels[element.notification.priority] || 'Unknown',
            //             content: element.notification.notification_text});
            //     }
            // });
            // Use Sets to track unique IDs for pending and completed notifications
            const pendingIds = new Set();
            const completedIds = new Set();

            data.forEach((element) => {
                const notification = {
                    id: element.notification.id,
                    status: element.notification_read ? 'Completed' : 'Pending',
                    title: element.notification.title,
                    received: element.notification.creation_date.substring(0, 10),
                    dueDate: element.notification.due_date,
                    action: 'Review',
                    priority: priorityLabels[element.notification.priority] || 'Unknown',
                    content: element.notification.notification_text,
                    supplierNumber: element.supplier_number,
                    attachments: element.attachments || [],
                };

                if (element.notification_read === false) {
                    // Add to pending only if the ID is not already in the Set
                    if (!pendingIds.has(notification.id)) {
                        pendingIds.add(notification.id);
                        pending.push(notification);
                    }
                } else {
                    // Add to completed only if the ID is not already in the Set
                    if (!completedIds.has(notification.id)) {
                        completedIds.add(notification.id);
                        completed.push(notification);
                    }
                }
            });

            setPendingRows(pending);
            setCompletedRows(completed);
        }catch (e){
            console.error('Error fetching notifications:', e);
        }finally {
            setIsLoadingNotifications(false);
        }
    }

    const getStatusHeader =(status) =>{
        return status === 'P' ? "Due Date" : "Done Date"
    }




    // Headers for Table
    const headers = [
        { label: 'Status', key: 'status' },
        { label: 'Title', key: 'title' },
        { label: 'Received', key: 'received' },
        { label: getStatusHeader(showComponent), key: 'dueDate' },
        { label: 'Supplier #', key: 'supplierNumber' },
        { label: 'Action', key: 'action' },
    ];


    //Initial load
    useEffect(() => {
        const initializeDropdown = async () => {
            if (supplierList && supplierList.length > 1) {
                // If more than one supplier, set ALL MY SUPPLIERS as default
                //Add "ALL MY SUPPLIERS" to the beginning of the list
                const formattedList = [...supplierList]; // Safe copy
                formattedList.unshift(ALL_MY_SUPPLIERS_STRING); // Add at the beginning
                setDropdownSuppliers(formattedList);

                //Set default supplier
                //Get all my suppliers
                const allSuppliersNumbers = supplierList.map(supplier => supplier.slice(0, 10));
                await fetchData(allSuppliersNumbers);

                //Concatenate label
                //e.g  ALL MY SUPPLIERS | 0000329141 - SPECIALTY RESOURCES INC | 0000456789 - GLOBAL TECH INC
                const allSupplierLabels = supplierList.map(supplier => supplier);
                const label = (userType === 'Supplier Employee') ? `${allSupplierLabels.join(' | #')}` : "Admin or Coordinator - Showing all notifications";
                setSelectedSupplierLabel(label);
            } else if (supplierList && supplierList.length === 1) {
                //If only one supplier, set it as the default
                const supplierNumber = supplierList[0].slice(0, 10);
                setSelectedSupplierLabel(supplierList[0]);
                await fetchData([supplierNumber]);
                setDropdownSuppliers(supplierList);
            }
            //If IT admin or coordinator, must type supplier in dropdown
        }

      initializeDropdown();
    }, [supplierList])

    useEffect(() => {
        if (pendingRows.length === 0 || !pendingRows) {
            updatePendingState(true)
        } else {
            updatePendingState(false)
        }
    }, [pendingRows, updatePendingState])

    // Open review view
    const handleReview = async (row, supplierNumber) => {
        setSelectedRow(row);
        setReview(true);
    };

    // Handle Sorting
    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });

        const sortedRows = [...(showComponent === 'P' ? pendingRows : completedRows)].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });
        showComponent === 'P' ? setPendingRows(sortedRows) : setCompletedRows(sortedRows);
    };

    const handleChange = (event) => {
        if (event.target.checked) {
            setBtnDisplay(false)
        }
        else {
            setBtnDisplay(true)
        }
    }

    const handleSubmit = async () => {
        setIsLoadingSubmitted(true);
        try {
            if (selectedRow) {
                const response = await notificationApi.put(
                    '/notifications/update-read-status',
                    null,
                    {
                        params: {
                            notification_id: selectedRow.id,
                            supplier_number: selectedRow.supplierNumber,
                            status: true
                        }
                    }
                );

                if (response.status === 200) {
                    console.log('Notification marked as read:', response.data);
                    setPendingRows(pendingRows.filter(ele => ele.id !== selectedRow.id))
                    setCompletedRows([...completedRows, {...selectedRow, status: 'Complete'}])
                    setSubmitted(true)
                } else {
                    setSubmitted(false)
                    console.error('Unexpected response status:', response.status);
                }
            }
        } catch (error) {
            setSubmitted(false);
            console.error('Error marking notification as read:', error);
        } finally {
            setIsLoadingSubmitted(false);
        }
    }

    const handleReturn = () => {
        setReview(false)
        setSubmitted(false)
        setBtnDisplay(true)
        setShowComponent('C')
    }

    const handleClose = () => {
        setReview(false);
        setSubmitted(false);
        setBtnDisplay(true)
        setSelectedRow(null);
    }

    const supplierChangeHandler = async (event) => {
        if (event.value === ALL_MY_SUPPLIERS_STRING) {
            //Fetch notifications for all my suppliers

            //Get all my suppliers
            const allSuppliersNumbers = supplierList.map(supplier => supplier.slice(0, 10));
            await fetchData(allSuppliersNumbers);

            //Concatenate label
            //e.g  ALL MY SUPPLIERS | 0000329141 - SPECIALTY RESOURCES INC | 0000456789 - GLOBAL TECH INC
            const allSupplierLabels = supplierList.map(supplier => supplier);
            const label = `${allSupplierLabels.join(' | #')}`;
            setSelectedSupplierLabel(label);
        }else{
            //Fetch single supplier notifications
            const supplierNumber = event.slice(0, 10);
            setSelectedSupplierLabel(event);
            await fetchData([supplierNumber]);
        }
    }

    const sanitizeFilename = (name, fallback = 'attachment') => {
        const safe = (name ?? fallback)
            .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_') // remove invalid chars
            .slice(0, 200); // avoid extremely long names
        return safe || fallback;
    };

    const isExpired = (expiresAt) => {
        if (!expiresAt) return false;
        const exp = new Date(expiresAt).getTime();
        const now = Date.now();
        return Number.isFinite(exp) && exp <= now;
    };

    const downloadBlob = (blob, filename) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename);
        link.style.display = 'none';
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    };

    // Download attachments sequentially
    const handleDownloadAttachments = async () => {
        try {
            console.log('Downloading attachments for notification ID:', selectedRow.id)

            // Fetch attachments presigned urls list for this notification
            const { data } = await notificationApi.get(
                '/notifications/attachments',
                { params: { notification_id: selectedRow.id } }
            );

            if (!Array.isArray(data) || data.length === 0) {
                console.warn('No attachments found to download.');
                return;
            }

            // Download SEQUENTIALLY (to avoid too many parallel requests)
            for (let i = 0; i < data.length; i++) {
                const item = data[i] || {};
                const url = item.url;
                const filepath = item.full_path;  //e.g 'scs-edi-self-service/myfile.pdf'
                const filename = filepath?.split('/').pop();
                const expiresAt = item.expiresAt;

                if (!url) {
                    console.warn(`Attachment #${i + 1} is missing a  URL.`);
                    continue;
                }

                if (isExpired(expiresAt)) {
                    console.warn(`The attachment "${filename || `attachment-${i + 1}`}" has expired (${expiresAt}).`);
                    continue;
                }


                const safeName = sanitizeFilename(filename, `attachment-${i + 1}`);

                // Note: the S3 bucket must have CORS enabled to allow GET from your origin
                const fileResponse = await axios.get(url, { responseType: 'blob' });

                // Keep the content-type if coming from S3
                const contentType = fileResponse.headers && fileResponse.headers['content-type']
                    ? fileResponse.headers['content-type']
                    : 'application/octet-stream';

                const blob = fileResponse.data instanceof Blob
                    ? fileResponse.data
                    : new Blob([fileResponse.data], { type: contentType });

                downloadBlob(blob, safeName);
                console.log(`Attachment #${i + 1} downloaded: ${safeName}`);
            }
        } catch (error) {
            console.error('There was an error while downloading attachments:', error);
        }
    };

    return (
        <Box p={2}>
            {review === true ?
                <Card className="review-container" >

                    <CancelIcon onClick={handleClose} className='cancel-icon' />
                    <Box className='review-header'>
                        <img src={logo} alt="Company logo" className='company-logo' />
                        <Box>
                            <Typography size="lg" fontWeight="bold" component="h1">{selectedRow.title}</Typography>
                            <Typography variant="subtitle1">Company - Initiative</Typography>
                            {selectedRow.attachments?.length > 0 && (
                                <Typography
                                    variant='h3'
                                    component="a"
                                    style={{
                                        textDecoration: 'underline',
                                        color: 'green',
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleDownloadAttachments}
                                >
                                    Download attachments
                                </Typography>
                            )}
                        </Box>
                        {!submitted &&
                            <Box className='review-meta'>
                                <Typography variant="subtitle1">Priority:<strong> {selectedRow.priority}</strong> </Typography>
                                <Typography variant="subtitle1">Due date:<strong> {selectedRow.dueDate}</strong></Typography>
                            </Box>
                        }
                    </Box>
                    <Box>
                        {isLoadingSubmitted ? (
                            <div className='submitted-section'>
                                <LoadingCard loadingText={"Updating notification..."}/>
                                <div className='footer'>
                                    <Divider className='divider' />
                                    <div className='footer-actions'>
                                        <Button size="medium" variant="primary" disabled onClick={handleReturn}>
                                            Return
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : submitted === true ? (
                            <div className='submitted-section'>
                                <CheckCircleIcon fontSize="medium" color="success" />
                                <Typography color="grey" fontWeight="600" component="h2" gutterBottom variant="h1">
                                    Submitted
                                </Typography>
                                <div className='footer'>
                                    <Divider className='divider' />
                                    <div className='footer-actions'>
                                        <Button size="medium" variant="primary" fontWeight="600" onClick={handleReturn}>
                                            Return
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <Box className='review-content'>
                                    <Typography sx={{
                                        whiteSpace: 'pre-line', padding: "0.90rem"
                                    }}>
                                        {selectedRow.content}
                                    </Typography>
                                </Box>
                                <div className='footer'>
                                    <Divider className='divider'/>
                                    <Typography color="grey" data-fuel-size="xs" className='acknowledge-text'>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="acknowledge"
                                                    onChange={handleChange}
                                                />
                                            }
                                        />
                                        I acknowledge and will make the necessary adjustments
                                    </Typography>
                                    <div className='footer-actions'>
                                        <Button
                                            disabled={btnDisplay}
                                            size="medium"
                                            variant="primary"
                                            fontWeight="bold"
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </Box>
                </Card>
                :
                <>
                    <Card className='cardcontainers' style={{ width: "100%", marginBottom: "20px" }} >
                        <Typography variant="h3" fontWeight="semibold" component="p" gutterBottom>
                            Suppliers you have access: <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <SupplierSelectComponent
                            userType="Supplier Employee"
                            supplierList={dropdownSuppliers}
                            supplierChangeHandler={supplierChangeHandler}
                            handleKeyDown={handleKeyDown}
                        />
                    </Card>

                    <Box pl={5}>
                        <Button size="large" variant="secondary"
                                style={{ backgroundColor: showComponent === 'P' ? 'white' : '#c1b8b8', color: "#bb0503" }}
                            onClick={() => setShowComponent('P')}>
                            Pending
                        </Button>
                        &nbsp;
                        <Button size="large" variant="secondary"
                            style={{ backgroundColor: showComponent === 'C' ? 'white' : '#c1b8b8', color: "green" }}
                            onClick={() => setShowComponent('C')}>
                            Complete
                        </Button>
                    </Box>

                    <Card className="paddingcontainer display-txt" >
                        <Typography size="lg" fontWeight="bold" component="h1" marginBottom='0.35em'>
                            {selectedSupplierLabel !== '' ? `Notifications for: #${selectedSupplierLabel}` : 'Please select a supplier'}
                        </Typography>
                        <Typography color='grey' data-fuel-size={'xs'} gutterBottom>
                            {showComponent === 'P' ? 'Please choose a notification to complete' : 'Please choose a notification to read'}
                        </Typography>
                        <Divider className='txt-divider' />

                        <Box p={2}>
                            {selectedSupplierLabel === '' ?
                                <EmptySupplierCard/>
                                : isLoadingNotifications ?
                                    <LoadingCard loadingText={"Loading notifications..."}/>
                                    : !isLoadingNotifications && showComponent === 'P' && pendingRows.length === 0 ? (
                                        <AllDoneCard/>
                                    ) : !isLoadingNotifications && showComponent === 'C' && completedRows.length === 0 ? (
                                        <AllDoneCard/>
                                    ) : (
                                        <TableContainer style={{maxWidth: '995px', margin: 'auto'}}>
                                            <Table>
                                                <TableHead style={{borderBottom: 'none'}}>
                                                    <TableRow>
                                                        {headers.map((header, index) => (
                                                            <TableCell
                                                                key={index}
                                                                className="notify-head"
                                                                onClick={() => handleSort(header.key)}
                                                            >
                                                                {header.label} <UnfoldMoreIcon fontSize="small"/>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(showComponent === 'P' ? pendingRows : completedRows).map((row) => (
                                                        <TableRow key={row.id} style={{borderBottom: 'none'}}>
                                                            <TableCell colSpan={6} style={{padding: '0'}}>
                                                                <NotificationRow
                                                                    notification={row}
                                                                    onReview={handleReview}
                                                                    isPending={showComponent === 'P'}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )}
                        </Box>
                    </Card>
                </>}
        </Box>
    );
};


const EmptySupplierCard = () => (
    <div className='component-txt'>
        <InfoIcon fontSize="medium" color="action"/>
        <Typography
            color='grey'
            fontWeight="bold"
            textAlign="center"
            mt={4}
            component={'h2'}
            gutterBottom
            variant={'h1'}
        >
            Please select a supplier
        </Typography>
    </div>
);

const LoadingCard = ({loadingText}) => (
    <div className='component-txt'>
        <CircularProgress color="primary" />
        <Typography
            color='grey'
            fontWeight="bold"
            textAlign="center"
            mt={4}
            component={'h2'}
            gutterBottom
            variant={'h1'}
        >
            {loadingText}
        </Typography>
    </div>
);

const AllDoneCard = () => (
    <div className='component-txt'>
        <CheckCircleIcon fontSize="medium" color="action"/>
        <Typography
            color='grey'
            fontWeight="bold"
            textAlign="center"
            mt={4}
            component={'h2'}
            gutterBottom
            variant={'h1'}
        >
            All done for the day
        </Typography>
    </div>
);

export default NotificationsComponent;
